export enum ZoneVariant {
  AVAILABLE = "available",
  OCCUPIED = "occupied",
  DISABLED = "disabled",
  FORBIDDEN = "forbidden",
  TEMP = "temp"
}
